import React from 'react';
import { Spinner } from 'components/atoms';
import BasicCrud   from 'components/basicCrud';
import User         from 'services/User';
import RemoveButton from 'components/RemoveButton';

function Item(props) {
  let {item, editHook} = props;
  let edit = () => {
    editHook(item.id);
  }
  return (
    <button onClick={edit} id={item.id} title="Кликните для редактирования" className="list-group-item list-group-item-action">
      <h5><strong className="ms-3">{item.name}</strong>
          ,&nbsp;
          <span>{item.email}</span>
      </h5>
    </button>
  );
}

function ItemEdit(props) {
  let {item, updateAttribute, save, cancel, remove, saving} = props;
  return (
    <form id={item.id} className="list-group-item">
      <h3>Редактировать пользователя</h3>
      <div className="row">
        <div className="col-3">
          <label htmlFor="itemName">Имя пользователя</label>
          <input type="text" className="form-control" id="itemName" name="name" value={item.name} onChange={updateAttribute}/>
        </div>
        <div className="col-3">
          <label htmlFor="itemFciNum">E-mail</label>
          <input type="text" className="form-control" id="itemEmail" name="email" value={item.email} onChange={updateAttribute}/>
        </div>
        <div className="col-3">
          <label htmlFor="itemFciNum">Пароль</label>
          <input type="password" className="form-control" id="itemPass" name="password" value={item.password} onChange={updateAttribute}/>
        </div>
        <div className="col-3">
          <label htmlFor="itemFciNum">Подтверждение пороля</label>
          <input type="password" className="form-control" id="itemPassConfirm" name="password_confirmation" value={item.password_confirmation} onChange={updateAttribute}/>
        </div>
      </div>
      <div className="mt-3">
        <button type="button" disabled={saving} onClick={save} className="btn btn-primary me-2">
          { (saving && <Spinner />) }
          Сохранить
        </button>
        <button disabled={saving} type="button" onClick={cancel} className="btn btn-light">Отмена</button>
        <RemoveButton disabled={saving} remove={remove} />
      </div>
    </form>
  );
}


export default class Users extends BasicCrud {

  constructor(props) {
    super(props);
    this.listName = 'Пользователи';
    this.modelClass = User;
    this.filterFields = [
      {
        name: 'name',
        label: 'Имя пользователя',
        className: 'col-4',
      },
      {
        name: 'email',
        label: 'E-mail',
        className: 'col-4',
      },
    ];
    this.state.filter = {
      name: '',
      email: '',
    };
  }

  renderItem = (item) => {
    if ( this.state.currentEditedItem === item.id ) {
      return <ItemEdit item={item}
        key={item.id}
        updateAttribute={this.itemUpdateAttribute}
        save={this.saveCurrentItem}
        cancel={this.cancelEditItem}
        remove={this.removeCurrentItem}
        saving={this.state.saving}
        />
    }
    return <Item item={item} editHook={this.editItem} key={item.id}/>
  }

}
